import {NavLink} from "react-router-dom";
import {WorkloadConfig} from "modules/integrations/validator.ts";
import navDataTest from "testUtils/navDataTest";
import {ServiceNav} from "ui-utils/ServiceNav.tsx";
import {endsWith} from "lodash";

const NewServiceNav = ({serviceConfig}: {serviceConfig: WorkloadConfig[]}) => {
    return <ServiceNav label={serviceConfig?.serviceNav?.label}>
        {serviceConfig?.serviceNav?.tabs?.map(tab => {
            return <NavLink to={
                serviceConfig.to && serviceConfig.to !== "/" && !tab.to.startsWith(serviceConfig.to) && !tab.to.startsWith(`${serviceConfig.to}`)
                    ? (endsWith(serviceConfig.to, "/") ? `${serviceConfig.to}${tab.to}` : `${serviceConfig.to}/${tab.to}`)
                    : tab.to
            } key={tab.to} data-testid={`${navDataTest.serviceNavItem}${tab.label}`}>
                {tab.label}
            </NavLink>
        })}
    </ServiceNav>
}

export default NewServiceNav;